var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-5 mb-5"},[_c('h4',{staticClass:"text-center mt-4"},[_vm._v("404 Page Not Found")]),_c('h5',{staticClass:"text-center mt-4"},[_c('b-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Go back to Home")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }